import { Button } from "@mui/material"
import { FC, useState } from "react"

type CounterProps = {
  initialValue: number
  increment?: number
}

// const Counter = (props: CounterProps) => {
const Counter: FC<CounterProps> = ({
  initialValue,
  increment = 1,
}) => {
  const [counter, setCounter] = useState(initialValue)

  return (
    <>
      <h1 data-testid="counter">{counter}</h1>
      <div style={{ display: 'flex' }}>
        <Button
          onClick={() => {
            setCounter(current => current - increment)
          }}
        >
          -
        </Button>
        <Button
          onClick={() => {
            setCounter(current => current + increment)
          }}
        >
          +
        </Button>
      </div>
    </>
  )
}

export default Counter